export default __webpack_public_path__ + "static/media/1.900dfdd8.png";